import script from "./ClaimInquiry.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClaimInquiry.vue?vue&type=script&lang=ts&setup=true"

import "./ClaimInquiry.vue?vue&type=style&index=0&id=377c9fa4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377c9fa4"]])

export default __exports__